// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1ywxs","topBottomGutter":"Layout_topBottomGutter__2ypc-"};